/* eslint-disable react/no-danger */
import React from "react";

function FAQQuestionAnswer({ questions, answer }: { questions: any; answer: string }) {
  return (
    <li className="m-1 p-1">
      <p className="fw-bold text-xxl">{questions}</p>
      <div dangerouslySetInnerHTML={{ __html: answer }} />
    </li>
  );
}

export default FAQQuestionAnswer;
